/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * TAF Delivery API
 * OpenAPI spec version: 1.0
 */

export type StartPageContentModelContentType = typeof StartPageContentModelContentType[keyof typeof StartPageContentModelContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StartPageContentModelContentType = {
  startPage: 'startPage',
} as const;
